import React from "react"
import { Row, Col } from 'antd';
import './style.scss'
const arrs = [
  'Malicious attacks for ML models to identify their vulnerability in black-box/real-world scenarios.',
  'The positive/negative social impacts and ethical issues related to adversarial ML.',
  'Novel algorithms and theories to improve model robustness.',
  'The consideration and experience of adversarial ML from industry and policy making.',
  'Benchmarks to reliably evaluate attack and defense methods and measure the real progress of the field. ',
  'Positive applications of adversarial ML, i.e., adversarial for good.',
  'Theoretical understanding of adversarial ML and its connection to other areas.',
]
export default function Call() {
  return <div className="call-box">
    <div className="page-call">
      <div className="call-title">Call for Papers</div>
      <div className="title-top">
        <p>Topics</p>
        <span>We welcome submission from different aspects of adversarial ML, including but not limited to:</span>
      </div>
      <Row className="list-ul">
        {arrs.map((item, index) => (
          <Col xl={12} span={24} className="list-li" key={index}>
            <b />
            {item}
          </Col>
        ))}
        <Col>
          <a target="blank" className="link" href="https://openreview.net/group?id=AAAI.org/2022/Workshop/AdvML">submission site</a>
        </Col>
        <Col className="list-list">
          We consider submissions that haven’t been published in any peer-reviewed venue (except those under review). The accepted papers will be allocated either a contributed talk or a poster presentation. Submissions including full papers (6-8 pages) and short papers (2-4 pages) should be anonymized and follow the AAAI-22 Formatting Instructions (two-column format) at <a href="https://www.aaai.org/Publications/Templates/AuthorKit22.zip">https://www.aaai.org/Publications/Templates/AuthorKit22.zip.</a>
        </Col>
        <Col className="list-text">
          Paper Awards: We will offer totally $3000 for the (2~3) best paper awards.
        </Col>
      </Row>
    </div>
  </div>

}
